import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Mail } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const EmptyAppsState: React.FC = () => {
  const { t } = useTranslation('dashboard');

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: 'easeOut' }}
      className="flex flex-col items-center justify-center py-24 px-6 text-center"
      role="status"
    >
      {/* Icon cluster */}
      <div className="relative mb-8" aria-hidden="true">
        <div className="w-24 h-24 rounded-2xl bg-gradient-to-br from-gray-100 to-gray-50 border border-gray-200 flex items-center justify-center shadow-sm">
          <Lock className="w-10 h-10 text-gray-400" strokeWidth={1.5} />
        </div>
        <div className="absolute -bottom-2 -right-2 w-8 h-8 rounded-lg bg-white border border-gray-200 shadow flex items-center justify-center">
          <Mail className="w-4 h-4 text-primary-400" strokeWidth={1.5} />
        </div>
      </div>

      {/* Text */}
      <h2 className="text-lg font-semibold text-gray-800 mb-2 font-rubik">
        {t('empty.title')}
      </h2>
      <p className="text-sm text-gray-500 max-w-xs leading-relaxed mb-6">
        {t('empty.description')}
      </p>

      {/* Hint pill */}
      <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gray-100 text-gray-500 text-xs font-medium">
        <Mail className="w-3.5 h-3.5" />
        {t('empty.contactHint')}
      </div>
    </motion.div>
  );
};

export default EmptyAppsState;

